import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  message,
  Popover,
  Row,
} from "antd";
import { useState } from "react";
import { MoreActionIcon } from "../../utils/icons";

type Props = {
  data: any;
  index: number;
  category: string;
  handleDelete?: any;
  handleClone?: any;
  handleRowExpand?: any;
};

const ActionMenu = (props: Props) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [popOverVisible, setPopOverVisible] = useState<any>([]);
  const [surfaceName, setSurfaceName] = useState<any>([""]);

  const handleVisibleChange = (visibleState: any, index: number) => {
    const prev = [...popOverVisible];
    prev[index] = true;
    setPopOverVisible(prev);
  };

  const handleSurfaceName = (e: any, index: number) => {
    const prev = [...surfaceName];
    prev[index] = e.target.value;
    setSurfaceName(prev);
  };

  const handleAddClone = (data: any, index: number) => {
    const title = surfaceName[index]?.trim();
    if (!title) {
      message.warning("Please enter a title", 2);
      return;
    }
    props.handleClone(data, index, surfaceName);
    const updatedPopOverVisible = [...popOverVisible];
    updatedPopOverVisible[index] = false;
    setPopOverVisible(updatedPopOverVisible);
  };

  const handlePopOverCancel = (index: number) => {
    const prev = [...popOverVisible];
    prev[index] = false;
    setPopOverVisible(prev);
  };

  return (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item
            key="1"
            style={{ fontWeight: "bold" }}
            onClick={() => props.handleDelete(props.data._id)}
          >
            Delete
          </Menu.Item>
          <Popover
            open={popOverVisible[props.index]}
            onOpenChange={(visible: any) =>
              handleVisibleChange(visible, props.index)
            }
            content={
              <div>
                <h3 style={{ fontWeight: "bold" }}>Enter Title:</h3>
                <Input
                  style={{ marginBottom: "8px" }}
                  value={surfaceName[props.index]}
                  onChange={(e: any) => handleSurfaceName(e, props.index)}
                />
                <Row justify="space-between" gutter={3}>
                  <Col>
                    <Button
                      type="primary"
                      onClick={() => handleAddClone(props.data, props.index)}
                    >
                      Add
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      onClick={() => handlePopOverCancel(props.index)}
                      type="primary"
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </div>
            }
            trigger="click"
          >
            <Menu.Item key="2" style={{ fontWeight: "bold" }}>
              Clone
            </Menu.Item>
          </Popover>
          {props.category === "paint" && (
            <Menu.Item
              onClick={() => props.handleRowExpand(props.data._id)}
              key="3"
              style={{ fontWeight: "bold" }}
            >
              Edit
            </Menu.Item>
          )}
          {props.category === "Equipment" && (
            <Menu.Item
              onClick={() => props.handleRowExpand(props.data._id)}
              key="3"
              style={{ fontWeight: "bold" }}
            >
              Edit
            </Menu.Item>
          )}
        </Menu>
      }
      trigger={["click"]}
    >
      <button className="action-button">
        <MoreActionIcon />
      </button>
    </Dropdown>
  );
};

export default ActionMenu;
